import { Money } from 'ts-money';

export function asCurrency(
  currency: string | undefined,
  amount: number | undefined,
): string {
  if (currency === undefined) currency = 'USD';
  if (amount === undefined) amount = 0;
  return amount.toFixed(2) + ' ' + currency;
}

export function asDisplayCurrency(
  displayExchangeRate: number | undefined,
  displayCurrency: string | undefined,
  amount: number,
): string {
  if (displayExchangeRate === undefined) displayExchangeRate = 1.0;
  if (displayCurrency === undefined) displayCurrency = 'USD';
  if (amount === undefined) amount = 0;
  return (amount * displayExchangeRate).toFixed(2) + ' ' + displayCurrency;
}

export interface MoneyDto {
  amount: number;
  currency: string;
}

export const toTsMoney = (dto: MoneyDto): Money =>
  Money.fromDecimal(dto, Math.ceil);
